import Vue from 'vue'
// edited
import box from './lan.svg'

// edited
Vue.component('lanIcon', box)